import { useEffect,useState } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import Pagination from '../Common/Pagination';
import { toast } from 'react-toastify';

const Details = () => {

    const [nationalCode,setNationalCode] = useState();
    const [surveys,setSurveys] = useState([]);
    const [surveyId,setSurveyId] = useState();
    const [surveyCode,setSurveyCode] = useState();
    const [rows,setRows] = useState([]);
    const [fetchedData,setFetchedData] = useState(false);
    const [showLottery,setShowLottery] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [fromDate,setFromDate] = useState();
    const [toDate,setToDate] = useState();
    const [winner,setWinner] = useState({});

    const [lastPage,setLastPage] = useState(0);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [count,setCount] = useState(0);

    const { readData: getOpinions } = useEntityCrud('Opinions/getAll');
    const { readData: getReports } = useEntityCrud('Report/Reportlottery');
    const { readData: lottery } = useEntityCrud('Report/PerformLottery');

    useEffect(() => {
        getOpinions().then(({ data }) => {
            let opinionsArr = [];
            if (data.status)
                data.result.map(item => {
                    opinionsArr.push({
                        label: item.title,
                        guildId: item.guildId,
                        value: item.id
                    });
                })
            setSurveys(opinionsArr);
        })
    },[]);

    const formatDate = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    const getData = () => {
        setIsLoading(true);
        const postedData = {
            p_offset: 1,
            p_limit: 20
        }
        if(surveyCode)
            postedData.p_ticket = surveyCode;
        if(nationalCode)
            postedData.p_nationalcode = nationalCode;
        if(surveyId){
            let codes = surveyId.map(survey => survey.value);
            codes = codes.join(',')
            postedData.p_opinion = codes;
        }
        getReports(postedData).then(({ data }) => {
            if(data.status && data.result.v_result.length){
                calcPages(data.result.v_count[0].cnt_total)
                setRows(data.result.v_result);
            }else{
                setRows([])
            }
        }).finally(() => {
            setFetchedData(true);
            setIsLoading(false);
        });
    }

    const doLottery = () => {
        setIsLoading(true);
        const postedData = {
            p_fromdate: formatDate(fromDate),
            p_todate: formatDate(toDate)
        }
        if(surveyId){
            let codes = surveyId.map(survey => survey.value);
            codes = codes.join(',')
            postedData.p_opinion = codes;
        }
        lottery(postedData).then(({ data }) => {
            if(data.status && data.result.v_result.length)
                setWinner(data.result.v_result[0]);
        }).finally(() => {
            setIsLoading(false);
        })
    }

    const calcPages = res => {
        let calcPages = res / 20;
        setCount(res)
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        setIsLoading(true);
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            p_limit: 20,
            p_offset: page
        };
        if(surveyCode)
            postedData.p_ticket = surveyCode;
        if(nationalCode)
            postedData.p_nationalcode = nationalCode;
        if(surveyId){
            let codes = surveyId.map(survey => survey.value);
            codes = codes.join(',')
            postedData.p_opinion = codes;
        }
        getReports(postedData).then(res => {
            setRows(res.data.result.v_result);
        }).catch(err => {err.data.errors.map(error => toast.error(error.message))}).finally(() => {
            setIsLoading(false);
        });
    }

    const prevPage = e => {
        setIsLoading(true);
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            p_limit: 20,
            p_offset: currentPage - 1
        };
        if(surveyCode)
            postedData.p_ticket = surveyCode;
        if(nationalCode)
            postedData.p_nationalcode = nationalCode;
        if(surveyId){
            let codes = surveyId.map(survey => survey.value);
            codes = codes.join(',')
            postedData.p_opinion = codes;
        }
        getReports(postedData).then(res => {
            setRows(res.data.result.v_result);
        }).catch(err => {err.data.errors.map(error => toast.error(error.message))}).finally(() => {
            setIsLoading(false);
        });
    }

    const nextPage = e => {
        setIsLoading(true);
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            p_limit: 20,
            p_offset: currentPage + 1
        };
        if(surveyCode)
            postedData.p_ticket = surveyCode;
        if(nationalCode)
            postedData.p_nationalcode = nationalCode;
        if(surveyId){
            let codes = surveyId.map(survey => survey.value);
            codes = codes.join(',')
            postedData.p_opinion = codes;
        }
        getReports(postedData).then(res => {
            setRows(res.data.result.v_result);
        }).catch(err => {err.data.errors.map(error => toast.error(error.message))}).finally(() => {
            setIsLoading(false);
        });
    }

    return (
        <div className="card">
            <div className="card-header px-4">
                <div className="card-title">ریز گزارشات قرعه کشی</div>
            </div>
            <div className="card-body p-4">
                {!!isLoading && <div className="loading-box">
                    <img src="/assets/images/loading.gif" alt="" />
                </div>}
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کد ملی</label>
                            <input type="tel" className="form-control ltr-input" maxLength={10} value={nationalCode} onChange={e => setNationalCode(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>نظرسنجی</label>
                            <ReactSelect
                                options={surveys}
                                value={surveyId}
                                isMulti
                                onChange={value => setSurveyId(value)}
                                placeholder="انتخاب کنید"
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کوپن نظرسنجی</label>
                            <input className="form-control ltr-input" maxLength={10} value={surveyCode} onChange={e => setSurveyCode(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-4" style={{marginTop: 30}}>
                        <button className="btn btn-primary pb-2 me-2" onClick={getData}>جستجو</button>
                        <button className="btn btn-secondary pb-2" onClick={() => setShowLottery(!showLottery)}>{showLottery ? 'مخفی کردن باکس قرعه کشی' : 'نمایش باکس قرعه کشی'}</button>
                    </div>
                </div>
                {showLottery ? <>
                <hr className="mt-4 mb-5" />
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group" style={{position: 'relative',zIndex: '0'}}>
                        <label>قرعه کشی از تاریخ</label>
                        {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                        <DatePicker
                            name="fromDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={fromDate}
                            onChange={setFromDate}
                            className="form-control"
                            inputPlaceholder='تاریخ  را انتخاب کنید ...'
                        />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group" style={{position: 'relative',zIndex: '0'}}>
                            <label>از تاریخ</label>
                            {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                name="toDate"
                                required
                                locale="fa"
                                shouldHighlightWeekends
                                value={toDate}
                                onChange={setToDate}
                                className="form-control"
                                inputPlaceholder='تاریخ  را انتخاب کنید ...'
                            />
                        </div>
                    </div>
                    <div className="col-md-2" style={{marginTop: 30}}>
                        <button className="btn btn-success pb-2" onClick={doLottery}>انجام قرعه کشی</button>
                    </div>
                </div>
                {Object.keys(winner).length ? <>
                    <hr className="mt-1 mb-5" />
                    <h5 className="mt-3 mb-5">برنده قرعه کشی :</h5>
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>شناسه ردیف</th>
                                <th>نام و نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>شماره همراه</th>
                                <th>نظرسنجی</th>
                                <th>نام شرکت</th>
                                <th>نام کسب و کار</th>
                                <th>تیکت</th>
                                <th>تاریخ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{winner.row_id || '-'}</td>
                                <td>{winner.full_name}</td>
                                <td>{winner.nationalcode}</td>
                                <td>{winner.consumer_mobile}</td>
                                <td>{winner.opnion_title}</td>
                                <td>{winner.companyname}</td>
                                <td>{winner.business_id}</td>
                                <td>{winner.ticket_number}</td>
                                <td>{winner.answerdate}</td>
                            </tr>
                        </tbody>
                    </table>
                </> : ''}
                </> : ''}
                {fetchedData && rows.length && !showLottery ? <hr className="mt-1" /> : ''}
                {fetchedData && rows.length && !showLottery ? <><table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>شناسه ردیف</th>
                            <th>نام و نام خانوادگی</th>
                            <th>کد ملی</th>
                            <th>شماره همراه</th>
                            <th>نظرسنجی</th>
                            <th>نام شرکت</th>
                            <th>نام کسب و کار</th>
                            <th>تیکت</th>
                            <th>تاریخ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row,index) => <tr key={index}>
                            <td>{row.row_id || '-'}</td>
                            <td>{row.full_name}</td>
                            <td>{row.nationalcode}</td>
                            <td>{row.consumer_mobile}</td>
                            <td>{row.opnion_title}</td>
                            <td>{row.companyname}</td>
                            <td>{row.business_name}</td>
                            <td>{row.ticket_number}</td>
                            <td>{`${row.answerdate.split(' ')[0].slice(0,4)}/${row.answerdate.split(' ')[0].slice(4,6)}/${row.answerdate.split(' ')[0].slice(6,8)}`}</td>
                        </tr>)}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {count || 0}</p>
                <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                </> : ''}
                {fetchedData && !rows.length ? <div className="alert alert-info mb-0"><p className="mb-0">داده ای یافت نشد !</p></div> : ''}
            </div>
        </div>
    )
}

export default Details;